import { render, staticRenderFns } from "./Korrespondenz.vue?vue&type=template&id=6995f64e"
import script from "./Korrespondenz.vue?vue&type=script&lang=js"
export * from "./Korrespondenz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports